import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralStyle = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.neutral.white};
  hr {
    height: 20px;
    width: 1px;
  }
`;

export const SectionWrapper = styled.div`
  display: grid;
  margin-top: 2rem;
  padding: 0.4rem;
  grid-template-columns: 1fr;
  grid-auto-rows: 1.5em 2em;
  align-items: center;

  label {
    font-weight: bold;
    font-size: 14px;
  }

  input,
  select {
    padding: 0.5em;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }

  input::placeholder {
    font-size: 12px;
  }
`;

export const ContentHeader = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 25px;
  padding-bottom: 20px;
  padding-left: 20px;
`;

export const ContentTitle = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  label {
    margin: 0 10px;
    color: #cc0000;
  }
  .title {
    font-size: 20px;
    color: ${({ theme }) => theme.primary.purple};
    font-weight: 700;
  }
  .mandatory-info {
    font-size: 14px;
    color: ${({ theme }) => theme.neutral.gray[2600]};
    font-weight: 400;
  }
  button {
    right: 15px;
    position: absolute;
  }
`;

export const ContentForm = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: minmax(30%, 300px) minmax(30%, 300px);
  grid-column-gap: 20px;
  padding-bottom: 40px;
  padding-left: 30px;
  margin-bottom: 13rem;
  .form-label {
    font-weight: 500;
    color: ${({ theme }) => theme.primary.purple};
  }
  .save-icon {
    align-self: center;
    margin-top: 25px;
    color: ${({ theme }) => theme.primary.purple};
    cursor: pointer;
  }
`;
export const TextField = styled.div`
  input,
  select {
    padding: 0.5em;
    height: 38px;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }
  label {
    color: #cc0000;
  }
  input::placeholder {
    font-size: 12px;
  }
  .lock-icon {
    position: absolute;
    right: 5px;
    top: 6px;
  }
`;

export const SelectField = styled.div`
  z-index: 10;
  label {
    color: #cc0000;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-bottom: 1rem;
`;

export const ButtonCancel = styled.button`
  border: 1px solid ${({ theme }) => theme.primary.purple};
  color: ${({ theme }) => theme.button.primary};
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  height: 43.21px;
  font-size: 14px;
  font-weight: 500;
  padding-left: 5rem;
  padding-right: 5rem;
  margin-right: 1rem;
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const ButtonCreateLob = styled.button`
  background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.primaryColorLight};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  height: 43.21px;
  padding-left: 5rem;
  padding-right: 5rem;
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
